import { useLanguage } from '@/components/utils/useLanguage';
import { HugeiconsIcon } from '@hugeicons/react';
import useFacilityLabels from '@/hooks/useFacilityLabels';
import { DEFAULT_ICON_BY_VALUE, getFacilityIcon } from '@/components/ui/ausstattungIcons';

export default function ActivityFacilities({ activity }) {
  const { t, language } = useLanguage();
  const { items, getLabel } = useFacilityLabels();

  const activeValues = activity.ausstattung || [];
  const activeItems = items.filter(i => activeValues.includes(i.value));
  if (!activeItems.length) return null;

  return (
    <div className="py-12 my-8">
      <h2 id="ausstattung" className="font-bold text-xl sm:text-2xl lg:text-3xl text-gray-900 mb-4">{t('Ausstattung', 'Facilities')}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2">
        {activeItems.map(item => {
          const IconComp = getFacilityIcon(item.icon || DEFAULT_ICON_BY_VALUE[item.value]);
          return (
            <div key={item.value} className="flex items-center gap-2 text-m text-gray-700">
              {IconComp && <HugeiconsIcon icon={IconComp} size={24} className="text-gray-700 flex-shrink-0" strokeWidth={1.5} />}
              <span>{getLabel(item.value, language)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}